export default "__VITE_ASSET__BzSohCUZ__"